import { ApiErrorMessageInterface } from '../interfaces';

export const ApiErrorMessages: ApiErrorMessageInterface = {
  CREATE_ANALYSIS_ERROR: 'There was a problem in creating analysis. Please try again.',
  WORKSPACE_CREATION_FAILURE_MESSAGE: 'Failed to Create Workspace',
};
